<template>
  <li v-if="node" class="link_container">
    <router-link v-if="node.val" :to="`/repos/${repoId}/docs/${node.val.id}`">
      {{ node.val.title }}
    </router-link>
    <ul v-if="node.children.length > 0">
      <doc-ref-node
        v-for="child in node.children"
        :key="child.val.name"
        :repo-id="repoId"
        :node="child"
      />
    </ul>
  </li>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "DocRefNode",
  props: {
    repoId: String,
    node: Object
  }
});
</script>

<style scoped>
.link_container {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  padding: 2px 0;
}
</style>
